









































import VueOptions from '@utils/VueOptions'
import CreativeEditor from '@ui/Creative/CreativeEditor'
import UpdateLineItemDiscountTriggerModal from '@triggers/CheckoutWizard/UpdateLineItemDiscountTriggerModal'
import UpdateAddonDiscountTriggerModal from '@triggers/CheckoutWizard/UpdateAddonDiscountTriggerModal'

import UpdateOriginalPriceTriggerModal from '@triggers/CheckoutWizard/UpdateOriginalPriceTriggerModal'
import UpdateOriginalPayoutTriggerModal from '@triggers/CheckoutWizard/UpdateOriginalPayoutTriggerModal'
import UpdateAddonOriginalPriceTriggerModal from '@triggers/CheckoutWizard/UpdateAddonOriginalPriceTriggerModal'
import UpdateAddonOriginalPayoutTriggerModal from '@triggers/CheckoutWizard/UpdateAddonOriginalPayoutTriggerModal'

settings =
  name: "CampaignCheckoutListingEdit"

  resources:
    listing_line_items:
      resourceName: 'shopping_cart_line_item'
      slug: 'campaigns/:campaignId/scanner/audience_listings/:listingId/shopping_cart_line_items'
      params:
        segment: ':segment'

    activation_plans:
      resourceName: 'activation_plan'
      slug: 'campaigns/:campaignId/activation_plans'
      fetch: false

  vue:
    components: {
      CreativeEditor,
      UpdateLineItemDiscountTriggerModal,
      UpdateAddonDiscountTriggerModal,
      UpdateOriginalPriceTriggerModal,
      UpdateOriginalPayoutTriggerModal,
      UpdateAddonOriginalPriceTriggerModal,
      UpdateAddonOriginalPayoutTriggerModal
    }

    data: ->
      creativeEditorModal:
        show: true

    computed:
      listingId: -> @$route.params.listingId
      segment: -> @$route.query.segment
      listingLineItems: -> @listing_line_items || []
      cartId: -> @listingLineItems[0]?.shopping_cart_id

      actionsForCreativeEditor: ->
        {
          @removeLineItem,
          @updateLineItemQuantity,
          @updateActivationDate,
          @addAddonLineItem,
          @removeAddon,
          @hiUpdateAddonQuantityFn,
          @promptUpdateLineItemDiscount,
          @promptUpdateAddonDiscount,
          @updateOriginalPriceTrigger,
          @updateOriginalPayoutTrigger,
          @updateAddonOriginalPriceTrigger,
          @updateAddonOriginalPayoutTrigger,
          @setVariable,
          @updateActivationDatesPlan,
          @updateMaxPalletCount,
          @selectShippingPlan,
        }

    methods:
      onListingLineItemsUpdateAddonQuantity: ->
        @fetch('listing_line_items')
        @fetchActivationPlans()

      removeLineItem: (lineItem) ->
        payloadOptions = { line_item_id: lineItem.id }
        @triggerResource 'listing_line_items', 'remove_line_item_from_cart', payloadOptions
      onListingLineItemsRemoveLineItemFromCart: ->

      removeAddon: (lineItem, addon) ->
        payloadOptions = { line_item_id: lineItem.id, addon_id: addon.id }
        @triggerResource 'listing_line_items', 'remove_addon_from_line_item', payloadOptions
      onListingLineItemsRemoveAddonFromLineItem: ->
        @fetchActivationPlans()

      addAddonLineItem: (lineItem, pricing_model) ->
        payload = { line_item_id: lineItem.id, pricing_model }
        @triggerResource 'listing_line_items', 'add_addon_line_item', payload
      onListingLineItemsAddAddonLineItem: ->
        @fetchActivationPlans()

      updateLineItemQuantity: (lineItem, startDate, snapToFit=true) ->
        payload = { line_item_id: lineItem.id, amount: parseInt(lineItem.quantity), start_date: startDate, snap_to_fit: snapToFit }
        @triggerResource 'listing_line_items', 'update_quantity', payload
      onListingLineItemsUpdateQuantity: ->
        @fetchActivationPlans()

      updateActivationDate: (lineItem) ->
        [starts_at, ends_at] = @activationDate
        payload = { line_item_id: lineItem.id, starts_at, ends_at }
        @triggerResource 'listing_line_items', 'update_activation_date', payload
      onListingLineItemsUpdateActivationDate: ->
        @fetchActivationPlans()

      hiUpdateAddonQuantityFn: (lineItem) ->
        (addon) =>
          payload = { line_item_id: lineItem.id, addon_id: addon.id, amount: parseInt(addon.quantity) }
          @triggerResource 'listing_line_items', 'update_addon_quantity', payload
      onListingLineItemsUpdateAddonQuantity: ->
        @fetchActivationPlans()

      promptUpdateLineItemDiscount: (lineItem) ->
        payloadOptions =
          line_item_id: lineItem.id
        modalOptions = { lineItem }
        @$refs.updateLineItemDiscountTrigger.fire(payloadOptions, modalOptions)
      onListingLineItemsUpdateLineItemDiscount: ->
        @$refs.updateLineItemDiscountTrigger.close()
        @creativeEditorModal.show = true

      promptUpdateAddonDiscount: (lineItem, addon) ->
        payloadOptions = { line_item_id: lineItem.id, addon_id: addon.id }
        modalOptions = { addon }
        @$refs.updateAddonDiscountTrigger.fire(payloadOptions, modalOptions)
      onListingLineItemsUpdateAddonDiscount: ->
        @$refs.updateAddonDiscountTrigger.close()
        @creativeEditorModal.show = true

      updateOriginalPriceTrigger: (lineItem) ->
        payloadOptions =
          line_item_id: lineItem.id
        modalOptions = { lineItem }
        @$refs.updateOriginalPriceTrigger.fire(payloadOptions, modalOptions)
      onListingLineItemsUpdateOriginalPrice: ->
        @$refs.updateOriginalPriceTrigger.close()
        @fetchActivationPlans()

      updateOriginalPayoutTrigger: (lineItem) ->
        payloadOptions =
          line_item_id: lineItem.id
        modalOptions = { lineItem }
        @$refs.updateOriginalPayoutTrigger.fire(payloadOptions, modalOptions)
      onListingLineItemsUpdateOriginalPayout: ->
        @$refs.updateOriginalPayoutTrigger.close()
        @fetchActivationPlans()

      updateAddonOriginalPriceTrigger: (lineItem, addon) ->
        payloadOptions =
          line_item_id: lineItem.id
          addon_id: addon.id
        modalOptions = { lineItem, addon }
        @$refs.updateAddonOriginalPriceTrigger.fire(payloadOptions, modalOptions)
      onListingLineItemsUpdateAddonOriginalPrice: ->
        @$refs.updateAddonOriginalPriceTrigger.close()
        @fetchActivationPlans()

      updateAddonOriginalPayoutTrigger: (lineItem, addon) ->
        payloadOptions =
          line_item_id: lineItem.id
          addon_id: addon.id
        modalOptions = { lineItem, addon }
        @$refs.updateAddonOriginalPayoutTrigger.fire(payloadOptions, modalOptions)
      onListingLineItemsUpdateAddonOriginalPayout: ->
        @$refs.updateAddonOriginalPayoutTrigger.close()
        @fetchActivationPlans()

      setVariable: (lineItem, name, value) ->
        @triggerResource 'listing_line_items', 'set_variable', { line_item_id: lineItem.id, name, value }
      onListingLineItemsSetVariable: ->

      updateActivationDatesPlan: (lineItem, startDate, endDate, snapToFit=true) ->
        payload = { line_item_id: lineItem.id, start_date: startDate, end_date: endDate, snap_to_fit: snapToFit }
        @triggerResource 'listing_line_items', 'update_activation_dates_plan', payload
      onListingLineItemsUpdateActivationDatesPlan: ->
        @fetchActivationPlans()

      updateMaxPalletCount: (lineItem, amount) ->
        payload = { line_item_id: lineItem.id, amount }
        @triggerResource 'listing_line_items', 'update_max_pallet_count', payload
      onListingLineItemsUpdateMaxPalletCount: ->
        @fetchActivationPlans()

      selectShippingPlan: (lineItem, type, snapToFit=true) ->
        payload = { line_item_id: lineItem.id, type, snap_to_fit: snapToFit }
        @triggerResource 'listing_line_items', 'change_shipping_plan_type', payload
      onListingLineItemsChangeShippingPlanType: ->
        @fetchActivationPlans()

      fetchActivationPlans: ->
        listingIds = (@ctxAudienceListing(lineItem).id for lineItem in @listing_line_items)
        @fetch 'activation_plans', { shopping_cart_id: @cartId, audience_listing_ids: listingIds }

export default VueOptions.vue settings
